<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT;font-size:20pt">Dedication</h1>
<p style="text-align: center;">To my nephews, Brandon and Isaiah, and my niece, Madison.</p>
<p style="text-align: center;">Lynn, papa loves you always.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?299dda2a